import { useCustomUpdateProposalWorksheetItemMutation } from "generated/graphql";
import getLocalString from "constants/Localization";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateProposalWorksheetItem() {
  const [mutation, { loading, data, error }] = useCustomUpdateProposalWorksheetItemMutation({
    refetchQueries: ["getProposal", "customGetProposal"],
    awaitRefetchQueries: true,
  });
  const [updateProposalWorksheetItem, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateProposalWorksheetItem",
    },
    {
      successMessage: getLocalString("worksheet.update-item-success"),
      failureMessage: getLocalString("worksheet.update-item-failure"),
      showValidationErrors: true,
    }
  );

  return [updateProposalWorksheetItem, context] as const;
}
